import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=2907f31d&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=ts&"
export * from "./Loader.vue?vue&type=script&lang=ts&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=2907f31d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907f31d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2907f31d')) {
      api.createRecord('2907f31d', component.options)
    } else {
      api.reload('2907f31d', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=2907f31d&scoped=true&", function () {
      api.rerender('2907f31d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/Loader.vue"
export default component.exports